// import React from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import HomePage from './pages/HomePage';
// import TeamPage from './pages/TeamPage';
// import GalleryPage from './pages/GalleryPage';
// import Blog from'./pages/Blog';
// import AdminDashboard from './pages/AdminDashboard';
// import AdminLogin from'./pages/AdminLogin';

// import './App.css';

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/team" element={<TeamPage />} />
//         <Route path="/gallery" element={<GalleryPage />} />
//         <Route path='/blog' element={<Blog/>}/>
//         <Route path="/admin/dashboard" element={<AdminDashboard />} />
//         <Route path="/admin-login" element={<AdminLogin />} />
         
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import TeamPage from "./pages/TeamPage";
import GalleryPage from "./pages/GalleryPage";
import Blog from "./pages/Blog";

import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";

// Student Module
import StudentLoginPage from "./pages/StudentLoginPage";
import StudentMaterialsPage from "./pages/StudentMaterialsPage";
import StudentProtectedRoute from "./components/StudentProtectedRoute";

import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Website */}
        <Route path="/" element={<HomePage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/blog" element={<Blog />} />

        {/* Admin */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />

        {/* Student */}
     

<Route path="/student/login" element={<StudentLoginPage />} />

<Route
  path="/student/materials"
  element={
    <StudentProtectedRoute>
      <StudentMaterialsPage />
    </StudentProtectedRoute>
  }
/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;